import script from "./MintCollateralControlsNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCollateralControlsNav.vue?vue&type=script&setup=true&lang=js"

import "./MintCollateralControlsNav.vue?vue&type=style&index=0&id=23989e92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23989e92"]])

export default __exports__